<template>
    <div class="flex-col page" :class="activeName == 1 ? 'unused' : 'used'">
        <div class="header" style="padding:0 16px; background:white;border-bottom:#E0E0E0 solid 0.5px;">
            <van-tabs v-model="activeName" color="#02d644" line-height="4px">
                <van-tab title="未使用" name="1"></van-tab>
                <van-tab title="已使用" name="2"></van-tab>
                <van-tab title="已过期" name="3"></van-tab>
                <van-tab title="已作废" name="4"></van-tab>
            </van-tabs>
        </div>
        <div class="flex-col coupon_list unused">
            <div class="flex-col list-item" :key="i" v-for="(item, i) in couponList" v-if="couponList.length != 0"
                @click="goCouponDetail(item)">
                <div class="flex-col items-center badge">
                    <span class="text_7">免费券</span>
                </div>
                <div class="flex-row group_6">
                    <img v-if="activeName == 1"
                        src="https://imgpub1.shouqiev.com/gofunplatform/files/20220818/ldNeEONAGB.png" alt=""
                        class="section_4">
                    <img v-else src="https://imgpub1.shouqiev.com/gofunplatform/files/20220818/DdnjDfcBGC.png" alt=""
                        class="section_4"></img>
                    <div class="flex-col items-start group_7">
                        <span class="text_9">免费洗车券</span>
                        <span class="text_11">有效期：{{ formatTime(item.startTime) }} 至
                            {{ formatTime(item.endTime) }}</span>
                    </div>
                </div>
                <div class="divider">
                    <!--*-->
                </div>
                <span class="text_13">NO：{{ item.couponCode }}</span>
            </div>
            <div v-if="couponList.length == 0" style="margin-top:200px;text-align:center;color:#ccc;">
                暂无数据
            </div>
        </div>
    </div>
</template>

<script>
import { Tab, Tabs } from "vant";
import "vant/lib/tab/style";
import "vant/lib/tabs/style";
import { getCouponList } from "../api";

Vue.use(Tab);
Vue.use(Tabs);
export default {
    components: {},
    data() {
        return {
            couponList: [{}],
            activeName: "1",
        };
    },
    watch: {
        activeName(val, oldVal) {
            this.getCouponList();
        },
    },
    methods: {
        formatTime(time) {
            return time ? time.split(" ")[0] : ''
        },
        goCouponDetail(item) {
            this.$router.push({
                path: `/salePassat/couponDetail/${item.couponCode}`,
            });
        },
        getCouponList() {
            getCouponList({
                orderId: this.$route.query.orderId,
                couponStatus: this.activeName,
            }).then((res) => {
                this.couponList = res.result.list;
            });
        },
    },
    created() {
        this.getCouponList();
    },
};
</script>

<style scoped lang="scss">
@import '../common.css';
.page.used {
    .badge {
        background-color: #ccc;
    }
}

.page.unused {
    .badge {
        background-color: #02d644;
    }
}

.page {
    background-color: #f5f5f5;
    overflow-x: hidden;
    height: 100%;

    .coupon_list {
        padding-top: 104px;
        margin: 0 0.21rem 0.21rem;

        .list-item {
            padding: 0 0.32rem 0.21rem;
            filter: drop-shadow(0px 0.21rem 0.21rem #0000000a);
            background-image: url("https://imgpub1.shouqiev.com/gofunplatform/files/20220819/ayxUUdcZdX.png");
            background-position: 0% 0%;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: relative;

            &:not(:first-of-type) {
                margin-top: 0.21rem;
            }

            .badge {
                padding: 0.11rem 0 0.053rem;
                border-radius: 0.21rem 0px 0.21rem 0px;
                width: 1.23rem;
                position: absolute;
                left: 0;
                top: 0;

                .text_7 {
                    color: #ffffff;
                    font-size: 0.27rem;
                    font-family: "FZLanTingHeiS-DB-GB";
                    line-height: 0.32rem;
                    font-weight: bold;
                    transform: scale(0.83);
                }
            }

            .group_6 {
                padding: 0.69rem 0 0.31rem;
                position: relative;

                .section_4 {
                    align-self: center;
                    width: 0.64rem;
                    height: 0.64rem;
                }

                .group_7 {
                    margin-left: 0.21rem;

                    .text_9 {
                        color: #141e25;
                        font-size: 0.43rem;
                        font-family: "PingFang SC";
                        font-weight: 500;
                        line-height: 0.59rem;
                    }

                    .text_11 {
                        margin-top: 0.11rem;
                        color: #999999;
                        font-size: 0.32rem;
                        font-family: "PingFang SC";
                        line-height: 0.45rem;
                    }
                }
            }

            .divider {
                background-image: repeating-linear-gradient(90deg,
                        #e0e0e0,
                        #e0e0e0 1.1940298507462688%,
                        transparent 1.1940298507462688%,
                        transparent 2.3880597014925375%);
                height: 0.027rem;
                position: relative;
            }

            .text_13 {
                margin-top: 0.21rem;
                align-self: flex-start;
                color: #999999;
                font-size: 0.32rem;
                font-family: "PingFang SC";
                line-height: 0.45rem;
                position: relative;
            }
        }
    }

    .header {

        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        height: 90px;
        z-index: 99;

        /deep/ .van-tab {
            &.van-tab--active {
                span {
                    font-weight: bold;
                }
            }

            margin-top:24px;
            height:44px;
            line-height:44px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// couponList.vue?166b9b55